const customersLang = {
  menuTitle: 'Contacts',
  company: 'Entreprise',
  person: 'Personne',
  customer: {
    label: 'Client',
    menu: 'Clients',
    addTitle: 'Nouveau client',
    editTitle: 'Modification d\'un client',
    addLabel: 'Créer un client',
    editLabel: 'Modifier le client',
    listTitle: 'Liste des clients',
    listReference: 'N° client'
  },
  prospect: {
    label: 'Prospect',
    menu: 'Prospects',
    addTitle: 'Nouveau prospect',
    editTitle: 'Modification d\'un prospect',
    addLabel: 'Créer un prospect',
    editLabel: 'Modifier le prospect',
    listTitle: 'Liste des prospects',
    listReference: 'N° prospect'
  },
  provider: {
    label: 'Fournisseur',
    menu: 'Fournisseurs',
    addTitle: 'Nouveau fournisseur',
    editTitle: 'Modification d\'un fournisseur',
    addLabel: 'Créer un fournisseur',
    editLabel: 'Modifier le fournisseur',
    listTitle: 'Liste des fournisseurs',
    listReference: 'N° fournisseur'
  },
  subcontractor: {
    label: 'Sous-traitant',
    menu: 'Sous-traitants',
    addTitle: 'Nouveau sous-traitant',
    editTitle: 'Modification d\'un sous-traitant',
    addLabel: 'Créer un sous-traitant',
    editLabel: 'Modifier le sous-traitant',
    listTitle: 'Liste des sous-traitants',
    listReference: 'N° sous-traitant'
  },
  list: {
    name: 'Nom',
    companyName: 'Nom entreprise',
    activity: 'Activité',
    origin: 'Origine',
    addressRoad1: 'Adresse rue 1',
    addressRoad2: 'Adresse rue 2',
    addressRoad3: 'Adresse rue 3',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    phone: 'Téléphone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    website: 'Site internet',
    commercial: 'Commercial',
    tags: 'Mots-clés',
    siret: 'N°SIRET',
    vatrate: 'N°TVA intracommunautaire',
    tiers: 'Tiers',
    firstname: 'Prénom',
    lastname: 'Nom de famille',
    civility: 'Civilité',
    function: 'Fonction',
    comments: 'Commentaires',
    birthDate: 'Date de naissance',
    customerType: 'Type de tiers',
    customerAccount: 'Compte client',
    providerAccount: 'Compte fournisseur',
    salesStatistics: 'Chiffre d\'affaires',
    salesStatisticsPreviousYear: 'Chiffre d\'affaires année en cours',
    salesStatisticsCurrentYear: 'Chiffre d\'affaires année N-1',
    toPaid: 'Paiement en attente',
    waitingQuotations: 'Devis en attente'
  },
  filters: {
    companyName: 'Entreprise',
    lastname: 'Nom',
    phone: 'Téléphone fixe',
    mobile: 'Téléphone portable',
    allPhone: 'Téléphone fixe ou portable',
    allTags: 'Tous les mots-clés',
    archived: 'Archiver'
  },
  contact: {
    label: 'Contact',
    menu: 'Contacts',
    tabTitle: 'Contacts',
    addTitle: 'Nouveau contact',
    editTitle: 'Modification d\'un contact',
    addLabel: 'Créer un contact',
    editLabel: 'Modifier le contact',
    listTitle: 'Liste des contacts',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
    merge: 'Fusionner avec un autre contact',
    mergeTitle: 'Fusion du contact avec un autre contact',
    mergeBtn: 'Fusionner',
    mergeDestination: 'Contact de destination :',
    mergeExplain1: 'Tous ses éléments liés à ce contact seront rattachés au nouveau contact et ce contact sera supprimé.',
    mergeExplain2: 'Attention, cette action est irreversible.',
  },
  documentTabTitle: 'Documents',
  deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce tiers ?',
  form: {
    type: 'Type de tiers :',
    companyName: 'Nom de l\'entreprise',
    civility: 'Civilité',
    firstname: 'Prénom',
    lastname: 'Nom',
    address: 'Adresse',
    tiers: 'Tiers :',
    function: 'Fonction :',
    comments: 'Commentaires :',
    invoiceAddress: 'Adresse de facturation',
    deliveryAddress: 'Adresse de livraison',
    useInvoiceAddress: 'Utiliser l\'adresse de facturation',
    coordinates: 'Coordonnées',
    phone: 'Téléphone :',
    mobile: 'Portable :',
    fax: 'Fax :',
    email: 'Email :',
    website: 'Site internet :',
    tags: 'Mots-clés :',
    activity: 'Activité',
    origin: 'Origine :',
    siret: 'Siret :',
    vatrate: 'N° TVA-intracommunautaire :',
    commercial: 'Commercial :',
    newsletter: 'Inscription à la newsletter :',
    newsletterExplain: 'Constituez votre base de données pour l\'envoi de newsletter à vos prospects et clients.',
    birthDate: 'Date de naissance',
    customerAccount: 'Compte client',
    providerAccount: 'Compte fournisseur'
  },
  item: {
    elements: 'Éléments',
    subscription: 'Abonnement',
    opportunities: 'Opportunités',
    sales: 'Ventes',
    contracts: 'Contrats',
    sepa: 'Mandats SEPA',
    quotations: 'Devis',
    commands: 'Bons de commande',
    deliveries: 'Bons de livraison',
    proformas: 'Factures proforma',
    depositInvoices: 'Factures d\'acompte',
    invoices: 'Factures',
    credits: 'Avoirs',
    payments: 'Encaissements',
    constructions: 'Chantiers',
    contactItem: 'Fiche contact',
    prospectItem: 'Fiche prospect',
    customerItem: 'Fiche client',
    providerItem: 'Fiche fournisseur',
    subcontractorItem: 'Fiche sous-traitant',
    noCoordinates: 'Aucune coordonnée',
    unarchive: 'Désarchiver',
    archive: 'Archiver',
    unarchiveConfirm: 'Êtes-vous sûr de vouloir désarchiver ce tiers ?',
    archiveConfirm: 'Êtes-vous sûr de vouloir archiver ce tiers ?',
    isArchived: 'Ce tiers est archivé',
    customerReference: 'Référence client',
    prospectReference: 'Référence prospect',
    providerReference: 'Référence fournisseur',
    subcontractorReference: 'Référence sous-traitant',
    addContact: 'Nouveau contact',
    salesPreferences: 'Préférences vente',
    chargesPreferences: 'Préférences charges',
    downloadPdf: 'Fiche PDF',
    catalog: 'Catalogue',
    purchases: 'Achats',
    catalogCommands: 'Commandes',
    charges: 'Charges',
    merge: 'Fusionner avec un autre tiers',
    mergeTitle: 'Fusion du tiers avec un autre tiers',
    mergeBtn: 'Fusionner',
    mergeDestination: 'Tiers de destination :',
    mergeExplain1: 'Tous ses éléments liés à ce tiers seront rattachés au nouveau tiers et ce tiers sera supprimé.',
    mergeExplain2: 'Attention, cette action est irreversible.',
    birthDate: 'Date de naissance',
    customerAccount: 'Compte client',
    providerAccount: 'Compte fournisseur',
    createdAt: 'Date de création',
    updatedAt: 'Date de modification',
    transformedAt: 'Date de transformation',
    salesStatistics: 'Chiffre d\'affaires',
    salesStatisticsPreviousYear: 'Chiffre d\'affaires année en cours',
    salesStatisticsCurrentYear: 'Chiffre d\'affaires année N-1',
    toPaid: 'Paiement en attente'
  },
  params: {
    menu: 'Paramètres',
    pageTitle: 'Configuration des tiers',
    creationTitle: 'Création des tiers :',
    cannotCreateDouble: 'Empêcher la création de doublon',
    cannotCreateDoubleExplain: 'Impose de renseigner le prénom et le nom pour les particuliers',
    canCreateDouble: 'Permettre la création de doublon',
    canCreateDoubleExplain: 'Seul le nom sera obligatoire lors de la création de particuliers',
    referenceTitle: 'Numérotation des tiers',
    referencePrefix: 'Préfixe',
    referenceNextNumber: 'Prochain numéro',
    referenceLength: 'Nombre de chiffre',
    referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
    referenceYear4: 'l\'année sur 4 chiffres',
    referenceYear2: 'l\'année sur 2 chiffres',
    referenceMonth: 'le mois',
    referenceDay: 'le jour',
    accountTitle: 'Comptes comptable',
    accountExplain: 'Le numéro de compte client n\'est utile que pour les exports comptables. Il permet d\'identifier le client dans un logiciel comptable. Nous vous invitons à vous rapprocher de votre expert comptable pour connaître la nomenclature qu\'il utilise. Par défaut, un numéro de compte du type 401000001 pour les fournisseurs et 411000001 pour les clients est automatiquement généré lors de la création d\'un tiers. Le numéro de compte s\'incrémente automatiquement. Vous avez la possibilité de personnaliser cette numérotation en utilisant un préfixe + une partie du nom du tiers.',
    accountPrefix: 'Préfixe',
    accountLength: 'Nombre de lettre à utiliser',
    accountLengthDefault: 'Longueur des comptes par défaut',
    accountCustom: 'N° personnalisé',
    newsletterTitle: 'Inscription automatique à votre newsletter :',
    newsletterExplain: 'Constituez-vous une base de données pour l\'envoi de vos newsletters.'
  },
  civility: {
    menu: 'Civilités',
    pageTitle: 'Gestion des civilités',
    label: 'Nom de la civilité',
    label2: 'Nom court',
    new: 'Création d\'une civilité',
    edit: 'Modification d\'une civilité',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette civilité ?'
  },
  contactActivity: {
    menu: 'Activités des tiers',
    pageTitle: 'Gestion des activités des tiers',
    label: 'Nom de l\'activité',
    new: 'Création d\'une activité',
    edit: 'Modification d\'une activité',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette activité ?'
  },
  contactFunction: {
    menu: 'Fonctions des contacts',
    pageTitle: 'Gestion des fonctions des contacts',
    label: 'Nom de la fonction',
    new: 'Création de la fonction',
    edit: 'Modification de la fonction',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette fonction ?'
  },
  contactOrigin: {
    menu: 'Origines des tiers',
    pageTitle: 'Gestion des origines des tiers',
    label: 'Nom de l\' origine',
    new: 'Création de l\' origine',
    edit: 'Modification de l\' origine',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette origine ?'
  },
  customerType: {
    menu: 'Type de tiers',
    pageTitle: 'Gestion des types de tiers',
    label: 'Nom du type de tiers',
    isCompanylabel: 'Possède un nom d\'entreprise',
    isPersonlabel: 'Possède un prénom et un nom',
    new: 'Création d\'un type de tiers',
    edit: 'Modification d\'un type de tiers',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce type de tiers ?'
  },
  address: {
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
    newTitle: 'Création d\'une adresse',
    editTitle: 'Modification d\'une adresse',
    name: 'Nom de l\'adresse',
    useInvoice: 'Utiliser comme adresse de facturation par défaut',
    useDelivery: 'Utiliser comme adresse de livraison par défaut',
    address: 'Adresse :',
    list: 'Liste des adresses',
    addAddress: 'Créer une adresse',
    forInvoice: 'Adresse de facturation par défaut',
    forDelivery: 'Adresse de livraison par défaut',
    manage: 'Gérer les adresses',
    addLabel: 'Ajouter une adresse',
    editLabel: 'Modifier l\'adresse'
  },
  references: {
    customer: {
      delete: 'Supprimer la référence client',
      add: 'Attribuer une référence client',
      transform: 'Transformer en client',
      transformConfirm: 'Êtes-vous sûr de vouloir transformer le prospect en client ?'
    },
    prospect: {
      delete: 'Supprimer la référence prospect',
      add: 'Attribuer une référence prospect',
      transform: 'Transformer en prospect',
      transformConfirm: 'Êtes-vous sûr de vouloir transformer le client en prospect ?',
    },
    provider: {
      delete: 'Supprimer la référence fournisseur',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer la référence fournisseur ?',
      add: 'Attribuer une référence fournisseur',
      addConfirm: 'Êtes-vous sûr de vouloir attribuer une référence fournisseur ?'
    },
    subcontractor: {
      delete: 'Supprimer la référence sous-traitant',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer la référence sous-traitant ?',
      add: 'Attribuer une référence sous-traitant',
      addConfirm: 'Êtes-vous sûr de vouloir attribuer une référence sous-traitant ?'
    }
  },
  salesPreferences: {
    title: 'Paramètres par défaut des documents de vente',
    defaultTitle : 'Valeurs par défaut',
    displayOptions: 'Options de saisie et d\'affichage',
    globalDiscount: 'Remise générale',
    vatRate: 'Taux de TVA',
    currency: 'Devise',
    paymentTerm: 'Conditions de paiement',
    saleTerms: 'Conditions générales de vente',
    paymentMethods: 'Moyens de paiement par défaut',
    guaranteeHoldback: 'Retenue de garantie',
    guaranteeHoldbackOn: 'sur',
    advanceRate: 'Taux d\'acompte',
    escompteRate: 'Taux d\'escompe',
    penaltyRate: 'Taux de pénalité',
    globalVatRate: 'Sélection du taux de TVA',
    amountsType: 'Mode de saisie des montants',
    pdfAmounts: 'Affichage des montants dans le contenu du document',
    pdfModel: 'Modèle PDF',
    commissionTitle : 'Commissions sur les ventes',
    commissionPourcent: 'Pourcentage de commission',
    commissionPourcentExplain: 'Laisser vide pour utiliser la commission par défaut',
    commissionValidity: 'Activer les commissions jusqu\'au',
    commissionValidityExplain: 'N\'est utilisé que lorsque la durée est activée sur la commission'
  },
  chargesPreferences: {
    title: 'Paramètres par défaut des charges',
    vatRate: 'Taux de TVA',
    currency: 'Devise',
    chargeCategory: 'Catégorie de charge',
    paymentDelay: 'Calcul de la date limite de paiement',
    paymentTerm: 'Conditions de paiement',
    paymentDelayUseTerm: 'Utiliser la condition de paiement pour calculer la date de paiement',
    paymentDelayPart1: 'Paiement à',
    paymentDelayPart2: 'jours',
    fecExports: 'Exports comptable',
    fecIncludeCharge: 'Exclure ce fournisseur dans les exports des charges',
    fecIncludeBank: 'Exclure ce fournisseur dans les exports de la banque'
  }
}

export default {
  customers: customersLang
}
